import { Box, Button, Container, FormControl, Input, InputAdornment, InputLabel, Typography } from "@mui/material";

import banner from "../../assets/images/banner-login.webp";

import logo from "../../assets/logo/logo-sem-frase-branco.png";
import { RiLockPasswordFill } from "react-icons/ri";
import { BiSolidUser } from "react-icons/bi";
import { useContext, useEffect, useState } from "react";
import RegistrarModal from "./registrar";
import UserContext from "../../context";
import { useNavigate } from "react-router-dom";
import { UserService } from "../../services/usuarios";
import { toast } from "react-toastify";

const instance = new UserService();

const EntradaPage = () => {

    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    
    const navigate = useNavigate();

    const token = sessionStorage.getItem('token');

    useEffect(() => {
        //if(token) navigate("/beneficiario");
    }, []);

    const styleContainer: React.CSSProperties = {
        backgroundImage: `url(${banner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexGrow: 1,
        maxHeight: "70vh",
        alignItems: "center",
        justifyContent: "center",
    }

    const styleBoxLogin: React.CSSProperties = {
        borderRadius: "1em",
        overflow: "hidden"
    }
    const styleTextFrase: React.CSSProperties = {
        color: "#f3f3f3",
        fontSize: "1.5em",
        fontWeight: 600,
        margin: 0,
        padding: 0
    }
    const styleImage: React.CSSProperties = {
        height: "3em"
    }
    const styleBoxLogo: React.CSSProperties = {
        display: "flex",
        alignItems: "center",
        gap: "1.5em",
        backgroundColor: "#61b4c0dd",
        justifyContent: "center",
        padding: "1.5em"
    }
    const styleTextTitle: React.CSSProperties = {
        fontSize: "1.8em",
        fontWeight: 600
    }
    const styleBoxFlexEntradas: React.CSSProperties = {
        display: "flex",
        backgroundColor: "#f3f3f3dd",
        padding: "2.5em 0em"   
    }
    const styleBoxFlexSignup: React.CSSProperties = {
        padding: "0 6em",
        width: "50%"
    }
    const styleBoxFlexSingIn: React.CSSProperties = {
        width: "50%"
    }

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    
    const submit = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        const payload = {
            username,
            password
        }
        post(payload);
    }
    const post = (payload: any) => {

        instance.signIn(payload)
        .then(data => {
            console.log('res token', data);
            if(data.access_token){
                sessionStorage.setItem('token', data.access_token);
                getProfile(data.access_token);
            }
            
        })
        .catch(error => {
            
            let msg = error.response.data.message;
            if(msg) toast.error(msg)
            console.log('error post singin', error);

        });

    }
    
    const ctx = useContext(UserContext);

    const getProfile = (token: string) => {
        instance.getProfile(token)
        .then(data => {

            if(ctx?.setUser)
                ctx?.setUser(data);

            navigate("/beneficiario", { replace: true });
        })
        .catch(error => console.log('error get profile', error))
    }

    return <Box  style={styleContainer}>
        <RegistrarModal open={open} setOpen={setOpen}/>

        <Container component="div" style={styleBoxLogin}>
            <Box component="div" style={styleBoxLogo}>
                <img src={logo} style={styleImage}/>
                <Typography style={styleTextFrase}>Meu Plano de Saúde</Typography>
            </Box>
            <Box component="div" style={styleBoxFlexEntradas}>
                <Box component="div" style={styleBoxFlexSignup}>
                    <Typography variant="h2" color="#61b4c0" style={styleTextTitle}>Bem-Vindo à sua Innova</Typography>
                    <Typography variant="subtitle2">
                        <b>É sua primeira vez no Innova plano de saúde? </b> 
                        Realize seu cadastro para acessar todas as facilidades da Innova.
                    </Typography>
                    <Button variant="outlined" style={{ textTransform: "none"}} onClick={handleOpen}>Quero me cadastrar</Button>
                </Box>
                <Box component="div" style={styleBoxFlexSingIn}>
                    <Typography variant="h2" color="#0786d0" style={styleTextTitle}>Acesse sua Innova</Typography>
                    <ul>
                        <li>
                            <Box display="inline">
                                <Typography color="#0786d0" variant="body1" component="span">
                                Cliente?
                                </Typography>{' '}
                                Seu login é o <b>CPF</b>.
                            </Box>
                        </li>
                        <li>
                            <Box display="inline">
                                <Typography color="#61b4c0" variant="body1" component="span">
                                Cooperador?
                                </Typography>{' '}
                                Seu login é o <b>CRM</b>.
                            </Box>
                        </li>
                    </ul>
                    <Box component="form" onSubmit={(e) => submit(e)}>
                        <Box sx={{display: "flex", gap: 2}}>
                            <FormControl variant="standard">
                                <InputLabel htmlFor="input-usename">
                                    Usuário
                                </InputLabel>
                                <Input
                                    required
                                    autoComplete="off"
                                    id="input-usename"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <BiSolidUser color="#0786d0"/>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <FormControl variant="standard">
                                <InputLabel htmlFor="input-password">
                                    Senha
                                </InputLabel>
                                <Input
                                    required
                                    autoComplete="off"
                                    id="input-password"
                                    name="password" 
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <RiLockPasswordFill color="#0786d0"/>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Box>
                        <Button variant="outlined" color="secondary" type="submit" style={{ textTransform: "none", marginTop: "1em"}}>Entrar</Button>
                    </Box>
                </Box>
            </Box>
        </Container>
    </Box>
}
export default EntradaPage;